
export const cardStyles = (hovered) => {
  return {
    boxShadow: hovered ? '1px 5px 8px 2px #b2b2b2' : '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
    border: '1px solid #353535',
    zIndex: 1,
    color: "#353535",
    cursor: 'pointer',
    transition: '.23s box-shadow'
  };
};

export const cardBodyStyles = {
  padding: '1.25rem',
  textAlign: 'center'
};

export const cardBodyTextStyles = {
  fontSize: '4rem',
  lineHeight: '7rem',
  fontWeight: '500',
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  color: 'white'
};

export const cardFooterStyles = {
  textAlign: 'center',
  padding: '.75rem .9rem',
  backgroundColor: 'whitesmoke'
};

export const cardFooterTextStyles = {
  color: '#353535',
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  fontWeight: '400',
  lineHeight: '1.2em',
  fontSize: '.9rem'
};

export const cardIconStyles = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  color: 'white',
  fontSize: 'initial',
  verticalAlign: 'middle'
};

export const imgStyles = {
  width: '100px'
};
